module.exports = __webpack_public_path__ + "media/assets/images/category/Anniversary@2x-4e32001cc25a855c95e36b7408aa7143.png";